import * as d3 from "d3";
import {
    colonAnnotation,
    DEFAULT_AXIS_FONT_SIZE,
    inrFormatter,
    numberFormat,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName, resData) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName
    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 500,
        margin: { top: 40, right: 100, bottom: 100, left: 50 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    const axisTickFontPx = defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
    var axisfontsize = axisTickFontPx + 'px'
  //  var axislabelfontsize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + 'px'
    var axislabelfontcolor = chart.axisLabelFontColor
    var axisfontcolor = chart.axisFontColor


    // axios.post(url, filterParam).then(res => {
        let data = resData
        // main svg
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append('svg')
            .attr('width', chartWidth + chartMargin.left + chartMargin.right)
            .attr('height', chartHeight + chartMargin.top + chartMargin.bottom)
            .call(responsivefy)
            .append('g')
            .attr('transform', 'translate(' + chartMargin.left + ',' + chartMargin.top + ')')

        var g = svg.append('g')     // move right 20px.

        console.log("min", d3.min(data.map(function (d) {
            return d.metric2
        })))

        console.log("max", d3.max(data.map(function (d) {
            return d.metric2
        })))

        var metric1ColorScale = d3.scaleLinear()
            .range([0, 1])
            // .domain([d3.min(data.map(function (d) {
            //     return d.metric2})), d3.max(data.map(function (d) {
            //     return d.metric2;
            // }))])
            .domain(d3.extent(data, function (d) {
                return d.metric2;
            }))
        // .range(fw_progressive_1way)

        var color = d3.scaleLinear(d3.schemeBlues[3])
            .domain(d3.extent(data, function (d) {
                return d.metric2;
            }))


        // x-scale and x-axis

        var x1Scale = d3.scaleLinear()
            .domain([0, d3.max(data.map(function (d) {
                return d.metric1;
            }))])
            .range([0, d3.max(data.map(function (d) {
                return d.metric1 / (d.metric1 / (chartWidth / 2));
            }))]);

        var x1AxisLabel = d3.axisTop().scale(x1Scale).ticks(8).tickFormat(inrFormatter);

        console.warn(x1AxisLabel)

        // Setting up a way to handle the data
        var tree = d3.cluster()               // This D3 API method setup the Dendrogram datum position.
            .size([chartHeight, chartWidth / 2])    // Total width - bar chart width = Dendrogram chart width
            .separation(function separate(a, b) {
                return a.parent === b.parent            // 2 levels tree grouping for category
                || a.parent.parent === b.parent
                || a.parent === b.parent.parent ? 3.5 : 3.8
            })

        var stratify = d3.stratify()            // This D3 API method gives csv file flat data array dimensions.
            .id(function (d) {
                return d.dim1_name
            })
            .parentId(function (d) {
                return d.dim1_name.substring(0, d.dim1_name.lastIndexOf('^'))
            })


        console.log("dend", name)

        var root = stratify(data)
        tree(root)

// console.log("Dendogram root data",data,root, tree, root.sum(d=>d.metric1))
        // Draw every datum a line connecting to its parent.
        var link = g.selectAll('.link')
            .data(root.descendants().slice(1))
            .enter()
            .append('path')
            .attr('class', 'link-dendogram')
            .style('fill', function (d) {
                return color(d.data.metric2)
            })
            .attr('d', function (d) {
                return 'M' + d.y + ',' + d.x
                    + 'C' + (d.parent.y + 100) + ',' + d.x
                    + ' ' + (d.parent.y + 100) + ',' + d.parent.x
                    + ' ' + d.parent.y + ',' + d.parent.x
            })
            .style("stroke", "#555")
            .style("stroke-opacity", "0.4")
            .style("stroke-width", "1px");

        console.warn(link)

        // Setup position for every datum; Applying different css classes to parents and leafs.
        var node = g.selectAll('.node')
            .data(root.descendants())
            .enter()
            .append('g')
            .attr('class', function (d) {
                return 'node' + (d.children ? ' node--internal' : ' node--leaf')
            })
            .attr('transform', function (d) {
                return 'translate(' + d.y + ',' + d.x + ')'
            })

        // Draw every datum a small circle.
        node.append('circle')
            .attr('r', 4)
            .style('fill', (d) => {
                return metric1ColorScale(d.data.metric2)
            })

        // Setup G for every leaf datum.
        var leafNodeG = g.selectAll('.node--leaf')
            .append('g')
            .attr('class', 'node--leaf-g')
            .attr('transform', 'translate(' + 8 + ',' + -13 + ')')
            .style('fill', 'black')

        leafNodeG.append('rect')
            .attr('class', 'shadow')
            .style('fill', (d) => {
                return d.data.dim1_name.endsWith('Allocated') ? "#6baed6"
                    : d.data.dim1_name.endsWith('Spent') ? "#fcae91"
                        : color(d.data.metric2)
            })
            .attr('width', 2)
            .attr('height', 30)
            .attr('rx', 2)
            .attr('ry', 2)
            .transition()
            .duration(800)
            .attr('width', (d) => {
                return x1Scale(d.data.metric1)
            })


        leafNodeG.append('text')
            .attr('dy', 19.5)
            .attr('x', 8)
            .style('text-anchor', 'start')
            .style('fill', axisfontcolor)
            .style('font-size', axisfontsize)
            .text(function (d) {
                return d.data.dim1_name.substring(d.data.dim1_name.lastIndexOf('^') + 1) + ': ' + ' ' + numberFormat(d.data.metric1) + '(' + (100 * (d.data.metric1 / d.data.metric3)).toFixed(2) + '%)'
            })

        // Write down text for every parent datum
        var internalNode = g.selectAll('.node--internal')
        internalNode.append('text')
            .attr('y', -10)
            .style('text-anchor', 'middle')
            .style('fill', axislabelfontcolor)
            .style('font-size', axisfontsize)
            .text(function (d) {
                return d.data.dim1_name.substring(d.data.dim1_name.lastIndexOf('^') + 1)
            })

        // Attach axis on top of the first leaf datum.
        var firstEndNode = g.select(".node--leaf");
        firstEndNode.insert("g")
            .attr("class", "xAxisDendo")
            .attr("transform", "translate(" + 7 + "," + -25 + ")")
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', axisfontsize)
            .style('fill', axisfontcolor);


        // The moving ball
        var ballG = svg.insert("g")
            .attr("class", "ballG")
            .attr("transform", "translate(" + 1700 + "," + chartHeight / 2 + ")");

        ballG.insert("rect")
            .attr("class", "shadow")
            .style("fill", "steelblue")
            .attr("width", 100)
            .attr("height", 200)

        ballG.insert("text")
            .style("text-anchor", "middle")
            .attr("dy", 5)
            .text("0.0");

        // Animation functions for mouse on and off events.
        d3.selectAll(".node--leaf-g")
            .on("mouseover", handleMouseOver)
            .on("mouseout", handleMouseOut);

        function handleMouseOver(d) {
            var leafG = d3.select(this);
            console.log(leafG)
            var ballGMovement = ballG.transition()
                .duration(400)
                .attr("transform", "translate(" + (d.y
                        + x1Scale(d.data.metric1) - 50) + ","
                    + (d.x + 1.5) + ")");

            ballGMovement.select("rect")
                .style('fill', function () {
                    return d.data.dim1_name.endsWith('Allocated') ? "#6baed6"
                        : d.data.dim1_name.endsWith('Spent') ? "#fcae91"
                            : metric1ColorScale(d.data.metric2)
                })
                .attr("width", 500)
                .attr("height", 30)


            ballGMovement.selectAll("text")
                .delay(10)
                .attr("y", 18)
                //     .attr("dy","1.2em")
                .style("text-anchor", "start")
                .style('fill', axisfontcolor)
                .style('font-size', axisfontsize)
                .text(function () {
                    const name = d.data.dim1_name.split('^')
                    return name[4] != null ? name[1] + " || " + name[2] + " || " + name[3] +
                        " || " + name[4] + "\n" + chart.vizSpecific4 + "(" + "Bar Metric" + ")" + colonAnnotation + inrFormatter(d.data.metric1)
                        + "\n" + chart.vizSpecific5 + "(" + "Color Metric" + ")" + colonAnnotation + inrFormatter(d.data.metric2)
                        : name[3] != null ? name[1] + " || " + name[2] + " || " + name[3]
                            : name[1] + " || " + name[2] + "\n" + chart.vizSpecific4 + "(" + "Bar Metric" + ")" + colonAnnotation + inrFormatter(d.data.metric1)
                            + "\n" + chart.vizSpecific5 + "(" + "Color Metric" + ")" + colonAnnotation + inrFormatter(d.data.metric2)
                })


        }

        function handleMouseOut() {
            var leafG = d3.select(this);

            leafG.select("rect")
                // .style("opacity", 0)
                .attr("stroke-width", "0")

        }
    // })
}
